// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import { Bell, BellOff, Users, ChevronRight } from "lucide-react";
// import { toast } from "react-toastify";
// import { format, isSameDay } from "date-fns";
// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import PageLoader from "../../helpers/PageLoader";
// import { useSelector } from "react-redux";

// const WEEK_STATUS_CFG = {
//   present:        { label: "Present",   bg: "bg-green-500",  card: "bg-green-50 border-green-200",   text: "text-green-700",   badge: "bg-green-100 text-green-700"   },
//   checked_in:     { label: "In",        bg: "bg-blue-500",   card: "bg-blue-50 border-blue-200",     text: "text-blue-700",    badge: "bg-blue-100 text-blue-700"     },
//   late:           { label: "Late",   bg: "bg-amber-400",  card: "bg-amber-50 border-amber-200",   text: "text-amber-700",   badge: "bg-amber-100 text-amber-700"   },
//   half_day:       { label: "½",   bg: "bg-blue-400",   card: "bg-blue-50 border-blue-200",     text: "text-blue-700",    badge: "bg-blue-100 text-blue-700"     },
//   absent:         { label: "Absent",   bg: "bg-red-500",    card: "bg-red-50 border-red-200",       text: "text-red-700",     badge: "bg-red-100 text-red-700"       },
//   on_leave:       { label: "Leave",   bg: "bg-purple-400", card: "bg-purple-50 border-purple-200", text: "text-purple-700",  badge: "bg-purple-100 text-purple-700" },
//   holiday:        { label: "Holiday",   bg: "bg-pink-400",   card: "bg-pink-50 border-pink-200",     text: "text-pink-700",    badge: "bg-pink-100 text-pink-700"     },
//   week_off:       { label: "Week_Off",   bg: "bg-gray-300",   card: "bg-gray-50 border-gray-200",     text: "text-gray-400",    badge: "bg-gray-100 text-gray-400"     },
//   comp_off:       { label: "C",   bg: "bg-teal-400",   card: "bg-teal-50 border-teal-200",     text: "text-teal-700",    badge: "bg-teal-100 text-teal-700"     },
//   upcoming:       { label: "Future",   bg: "bg-gray-200",   card: "bg-gray-50 border-gray-100",     text: "text-gray-300",    badge: "bg-gray-50 text-gray-300"      },
//   yet_to_checkin: { label: "Yet_to_Checkin",   bg: "bg-orange-400", card: "bg-orange-50 border-orange-200", text: "text-orange-600",  badge: "bg-orange-100 text-orange-600" },
//   not_checked_in: { label: "?",   bg: "bg-orange-400", card: "bg-orange-50 border-orange-200", text: "text-orange-600",  badge: "bg-orange-100 text-orange-600" },
// };

// const AttendanceDashboard = () => {
//   const user = useSelector((state) => state.user.user);
  
//   const [attendance, setAttendance] = useState(null);
//   const [weeklySummary, setWeeklySummary] = useState([]);
//   const [teamData, setTeamData] = useState({ managers: { primary: null, secondary: [] }, reportees: [] });
//   const [timerDisplay, setTimerDisplay] = useState("00:00:00");
//   const [stats] = useState({ pending: 0, goal: 65 });
//   const [loading, setLoading] = useState(true);
//   const [isPunching, setIsPunching] = useState(false);

//   const formatTime12h = (timeString) => {
//     if (!timeString) return "--:--";
//     const [hours, minutes] = timeString.split(":");
//     let h = parseInt(hours, 10);
//     const ampm = h >= 12 ? "PM" : "AM";
//     h = h % 12 || 12;
//     return `${h}:${minutes} ${ampm}`;
//   };

//   const shiftTimings = useMemo(() => {
//     const startTime = attendance?.shiftId?.startTime || user?.shiftId?.startTime || "09:00";
//     const endTime = attendance?.shiftId?.endTime || user?.shiftId?.endTime || "18:00";
//     return { startTime, endTime };
//   }, [attendance, user]);

//   const isShiftEnded = useMemo(() => {
//     const now = new Date();
//     const currentMinutes = now.getHours() * 60 + now.getMinutes();
//     const [endH, endM] = shiftTimings.endTime.split(":").map(Number);
//     return currentMinutes >= (endH * 60 + endM);
//   }, [shiftTimings]);

//   const isPastRecord = useMemo(() => {
//     if (!attendance?.date) return false;
//     return !isSameDay(new Date(attendance.date), new Date());
//   }, [attendance]);

//   const fetchDashboardData = useCallback(async () => {
//     try {
//       setLoading(true);
//       const [todayRes, weeklyRes, teamRes] = await Promise.all([
//         api.get(SummaryApi.getTodayAttendanceStatus.url),
//         api.get(SummaryApi.weeklyAttendanceStatus.url),
//         api.get(SummaryApi.teamTdyAttendanceStatus.url),
//       ]);
//       if (todayRes.data.success) setAttendance(todayRes.data.data);
//       if (weeklyRes.data.success) setWeeklySummary(weeklyRes.data.data);
//       if (teamRes.data.success) setTeamData(teamRes.data.data);
//     } catch (err) {
//       console.error("Error fetching dashboard data", err);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchDashboardData();
//   }, [fetchDashboardData]);

//   useEffect(() => {
//     let interval;
//     const updateTimer = () => {
//       if (!attendance || !attendance.punches || attendance.punches.length === 0) {
//         setTimerDisplay("00:00:00");
//         return;
//       }
//       const lastPunch = attendance.punches[attendance.punches.length - 1];
//       let totalMs = (attendance.totalWorkingMinutes || 0) * 60000;

//       if (lastPunch.type === "in") {
//         const checkInTime = new Date(lastPunch.time);
//         let endTimeToCalculate = new Date();

//         if (isPastRecord) {
//           const [startH, startM] = shiftTimings.startTime.split(":").map(Number);
//           const todaysShiftStart = new Date();
//           todaysShiftStart.setHours(startH, startM, 0, 0);

//           if (endTimeToCalculate > todaysShiftStart) {
//             endTimeToCalculate = todaysShiftStart;
//           }
//         }

//         const diff = Math.max(0, endTimeToCalculate - checkInTime);
//         totalMs += diff;
//       }

//       const totalSeconds = Math.floor(totalMs / 1000);
//       const h = Math.floor(totalSeconds / 3600);
//       const m = Math.floor((totalSeconds % 3600) / 60);
//       const s = totalSeconds % 60;
//       setTimerDisplay(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`);
//     };
//     interval = setInterval(updateTimer, 1000);
//     return () => clearInterval(interval);
//   }, [attendance, isPastRecord, shiftTimings]);

//   const handlePunchAction = async () => {
//     if (isPunching) return;

//     if (navigator.geolocation) {
//       setIsPunching(true);

//       navigator.geolocation.getCurrentPosition(async (pos) => {
//         try {
//           const lastPunch = attendance?.punches?.[attendance.punches.length - 1];
//           const isCurrentlyIn = lastPunch?.type === "in";
          
//           const payload = { 
//             location: { lat: pos.coords.latitude, lng: pos.coords.longitude }, 
//             method: "web",
//             workMode: "office" 
//           };

//           const res = await api.post(isCurrentlyIn ? SummaryApi.checkOut.url : SummaryApi.checkIn.url, payload);
          
//           if (res.data.success) {
//             toast.success(isCurrentlyIn ? "Checked Out!" : "Checked In!");
//             await fetchDashboardData();
//           }
//         } catch (err) {
//           toast.error(err.response?.data?.message || "Error occurred during punch");
//         } finally {
//           setIsPunching(false);
//         }
//       }, (err) => {
//         setIsPunching(false);
//         toast.error("Please enable location access to punch.");
//       }, { enableHighAccuracy: true });
//     } else {
//       toast.error("Geolocation is not supported by your browser.");
//     }
//   };

//   // UPDATED: 'checked_in' ஸ்டேட்டஸ் வரும்போது "In" என்று நீல நிற பேட்ஜில் காட்டும் லாஜிக்
//   const getStatusConfig = (status, isCurrentlyIn) => {
//     if (isCurrentlyIn || status === 'checked_in') {
//       return { label: 'In', class: 'bg-blue-100 text-blue-600' };
//     }
//     switch (status) {
//       case 'present': return { label: 'Present', class: 'bg-green-100 text-green-600' };
//       case 'yet_to_checkin': return { label: 'Yet to check-in', class: 'bg-orange-100 text-orange-600' };
//       case 'absent': return { label: 'Absent', class: 'bg-red-100 text-red-600' };
//       case 'holiday': return { label: 'Holiday', class: 'bg-blue-100 text-blue-600' };
//       case 'on_leave': return { label: 'On Leave', class: 'bg-purple-100 text-purple-600' };
//       case 'week_off': return { label: 'Week Off', class: 'bg-gray-100 text-gray-400' };
//       case 'inactive': return { label: '-', class: 'bg-gray-50 text-gray-300' };
//       default: return { label: status, class: 'bg-gray-100 text-gray-600' };
//     }
//   };

//   const hhmToMins = (hhmm) => {
//     if (!hhmm) return 0;
//     const [h, m] = hhmm.split(':').map(Number);
//     return h * 60 + m;
//   };

//   const isoToLocalMins = (iso) => {
//     const d = new Date(iso);
//     return d.getHours() * 60 + d.getMinutes();
//   };

//   const fmtDur = (mins) => {
//     if (!mins || mins <= 0) return '0m';
//     const h = Math.floor(Math.abs(mins) / 60);
//     const m = Math.abs(mins) % 60;
//     if (h === 0) return `${m}m`;
//     if (m === 0) return `${h}h`;
//     return `${h}h ${m}m`;
//   };

//   const minsTo12h = (totalMins) => {
//     const h = Math.floor(totalMins / 60) % 24;
//     const m = totalMins % 60;
//     const ampm = h >= 12 ? 'PM' : 'AM';
//     return `${h % 12 || 12}:${String(m).padStart(2,'0')} ${ampm}`;
//   };

//   const buildSegments = (punches, shiftStart, shiftEnd, grace, nowMins) => {
//     if (!punches?.length) return { segments: [], markers: [] };

//     const ps = punches.map(p => ({ ...p, mins: isoToLocalMins(p.time) }));
//     const firstIn = ps[0];
//     const lastP   = ps[ps.length - 1];
//     const isIn    = lastP.type === 'in';

//     const windowEnd = Math.max(
//       shiftEnd + 30,
//       isIn ? nowMins + 30 : lastP.mins + 30
//     );
//     const windowDur = windowEnd - shiftStart;
//     const pct = (m) => Math.max(0, Math.min(100, ((m - shiftStart) / windowDur) * 100));

//     const segments = [];

//     if (firstIn && firstIn.mins > shiftStart + grace) {
//       segments.push({
//         key:   'late',
//         start: pct(shiftStart),
//         width: pct(firstIn.mins) - pct(shiftStart),
//         color: 'bg-red-400',
//         label: `Late ${fmtDur(firstIn.mins - shiftStart)}`,
//         sublabel: `${minsTo12h(shiftStart)} → ${minsTo12h(firstIn.mins)}`,
//       });
//     }

//     for (let i = 0; i < ps.length; i++) {
//       const cur  = ps[i];
//       const next = ps[i + 1];

//       if (cur.type === 'in') {
//         const endMins = next ? next.mins : (isIn ? nowMins : cur.mins);
//         const dur = endMins - cur.mins;

//         if (cur.mins < shiftEnd && endMins > shiftEnd) {
//           const regDur = shiftEnd - cur.mins;
//           segments.push({
//             key:   `work-${i}-reg`,
//             start: pct(cur.mins),
//             width: pct(shiftEnd) - pct(cur.mins),
//             color: 'bg-green-500',
//             label: `Work ${fmtDur(regDur)}`,
//             sublabel: `${minsTo12h(cur.mins)} → ${minsTo12h(shiftEnd)}`,
//             pulse: false,
//           });
//           const otDur = endMins - shiftEnd;
//           segments.push({
//             key:   `ot-${i}`,
//             start: pct(shiftEnd),
//             width: pct(endMins) - pct(shiftEnd),
//             color: 'bg-purple-500',
//             label: `OT ${fmtDur(otDur)}`,
//             sublabel: `${minsTo12h(shiftEnd)} → ${isIn && !next ? 'Now' : minsTo12h(endMins)}`,
//             pulse: isIn && !next,
//           });
//         } else if (cur.mins >= shiftEnd) {
//           segments.push({
//             key:   `ot-${i}`,
//             start: pct(cur.mins),
//             width: pct(endMins) - pct(cur.mins),
//             color: 'bg-purple-500',
//             label: `OT ${fmtDur(dur)}`,
//             sublabel: `${minsTo12h(cur.mins)} → ${isIn && !next ? 'Now' : minsTo12h(endMins)}`,
//             pulse: isIn && !next,
//           });
//         } else {
//           segments.push({
//             key:   `work-${i}`,
//             start: pct(cur.mins),
//             width: pct(endMins) - pct(cur.mins),
//             color: 'bg-green-500',
//             label: `Work ${fmtDur(dur)}`,
//             sublabel: `${minsTo12h(cur.mins)} → ${isIn && !next ? 'Now' : minsTo12h(endMins)}`,
//             pulse: isIn && !next,
//           });
//         }
//       }

//       if (cur.type === 'out' && next?.type === 'in') {
//         const dur = next.mins - cur.mins;
//         segments.push({
//           key:   `break-${i}`,
//           start: pct(cur.mins),
//           width: pct(next.mins) - pct(cur.mins),
//           color: 'bg-amber-300',
//           label: `Break ${fmtDur(dur)}`,
//           sublabel: `${minsTo12h(cur.mins)} → ${minsTo12h(next.mins)}`,
//         });
//       }
//     }

//     const markerSet = new Map();
//     markerSet.set(shiftStart, { mins: shiftStart, label: minsTo12h(shiftStart), isShift: true });
//     markerSet.set(shiftEnd,   { mins: shiftEnd,   label: minsTo12h(shiftEnd),   isShiftEnd: true });
//     ps.forEach(p => {
//       markerSet.set(p.mins, { mins: p.mins, label: minsTo12h(p.mins), isPunch: true, type: p.type });
//     });
//     if (isIn) {
//       markerSet.set(nowMins, { mins: nowMins, label: isPastRecord ? minsTo12h(nowMins) : 'Now', isNow: true });
//     }

//     const markers = [...markerSet.values()]
//       .sort((a, b) => a.mins - b.mins)
//       .map(m => ({ ...m, pct: pct(m.mins) }));

//     return { segments, markers, windowEnd, windowDur, pct };
//   };

//   if (loading) return <PageLoader />;

//   const isCurrentlyIn = attendance?.punches?.[attendance.punches.length - 1]?.type === "in";
//   const todayStatus = attendance?.status || 'yet_to_checkin';

//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 p-2 lg:p-0">
      
//       {/* Sidebar - Profile & Team */}
//       <div className="lg:col-span-4 xl:col-span-3 space-y-6">
//         <div className="bg-white rounded-lg p-8 shadow-sm border border-red-50 text-center">
//           <div className="relative inline-block mb-4">
//             <div className="w-24 h-24 bg-gray-100 rounded-full mx-auto overflow-hidden border-4 border-white shadow-md">
//               <img src={user?.profilePicture || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"} alt="User" className="w-full h-full object-cover" />
//             </div>
//             <div className={`absolute bottom-1 right-1 w-4 h-4 rounded-full border-2 border-white ${isCurrentlyIn ? "bg-green-500" : "bg-red-500"}`}></div>
//           </div>
//           <h2 className="text-xl font-bold text-gray-800">{user?.firstName} {user?.lastName}</h2>
//           <p className="text-gray-500 text-[10px] mb-6 font-semibold uppercase tracking-widest">{user?.designationId?.title || "Employee"}</p>

//           {/* Today Status Badge */}
//           <div className={`inline-block px-4 py-1 rounded-full text-[10px] font-semibold uppercase mb-6 ${getStatusConfig(todayStatus, isCurrentlyIn).class}`}>
//             Current: {getStatusConfig(todayStatus, isCurrentlyIn).label}
//           </div>

//           <div className="bg-red-50 text-red-600 font-mono text-2xl py-3 rounded-lg mb-4 tracking-widest border border-red-100">
//             {timerDisplay}
//           </div>

//           {/* நேற்றைய விடுபட்ட செக்-அவுட் எனில் எச்சரிக்கைக் குறியீடு காட்டுதல் */}
//           {isPastRecord && isCurrentlyIn && (
//             <p className="text-[10px] text-red-500 font-bold animate-pulse mt-1 mb-4 uppercase tracking-wider">
//               ⚠️ Yesterday's Open Session
//             </p>
//           )}

//             <button 
//               onClick={handlePunchAction} 
//               disabled={isPunching} 
//               className={`w-full py-4 rounded-lg font-bold shadow-lg text-white transition-all flex items-center justify-center gap-2 ${isPunching ? "opacity-70 cursor-not-allowed" : ""} ${isCurrentlyIn ? "bg-secondary" : "bg-red-600 hover:bg-red-700"}`}
//             >
//               {isPunching ? (
//                 <>
//                   <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
//                   Processing...
//                 </>
//               ) : (
//                 isCurrentlyIn ? (isPastRecord ? "Check-out Yesterday" : "Check-out") : "Check-in"
//               )}
//             </button>
//         </div>

//       {/* Team Section (Managers + Reportees) */}
//       <div className="space-y-6">
        
//         {/* 1. MANAGERS SECTION */}
//         {(teamData.managers?.primary || teamData.managers?.secondary?.length > 0) && (
//           <div className="space-y-3">
//             <div className="flex justify-between items-center px-2">
//               <h3 className="text-[11px] font-semibold text-textMuted uppercase tracking-widest">Reporting To</h3>
//               <Users size={12} className="text-textMuted" />
//             </div>

//             <div className="space-y-3">
//               {/* Primary Manager */}
//               {teamData.managers.primary && (
//                 <div className="bg-red-50/30 p-2 rounded-lg border-l-4 border-red-600 shadow-sm">
//                   <p className="text-[9px] font-semibold text-red-600 uppercase px-1 mb-1.5 flex items-center gap-1">
//                     <span className="w-1 h-1 bg-red-600 rounded-full"></span> Primary Manager
//                   </p>
//                   <div className="flex items-center justify-between bg-white p-2.5 rounded-lg border border-red-100/50">
//                     <div className="flex items-center gap-2.5">
//                       <img 
//                         src={teamData.managers.primary.profilePicture || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"} 
//                         className="w-8 h-8 rounded-full border-2 border-red-50 object-cover shadow-sm" 
//                         alt="mgr" 
//                       />
//                       <div className="flex flex-col">
//                         <p className="text-[11px] font-bold text-gray-800 leading-tight">{teamData.managers.primary.name}</p>
//                         <p className="text-[10px] text-red-500 font-semibold leading-tight mt-0.5">{teamData.managers.primary.designation}</p>
//                         <p className="text-[8px] text-gray-400 font-mono tracking-tighter uppercase">{teamData.managers.primary.userId}</p>
//                       </div>
//                     </div>
//                     {/* UPDATED: மேலாளர் நேற்று செக்-அவுட் செய்யவில்லை என்றால் "In (Yesterday)" என்று காட்டும் */}
//                     <div className={`px-2 py-0.5 rounded-full text-[9px] font-semibold uppercase ${getStatusConfig(teamData.managers.primary.status, false).class}`}>
//                       {getStatusConfig(teamData.managers.primary.status, false).label}
//                       {teamData.managers.primary.isYesterdayPunch && " (Yesterday)"}
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Secondary Managers */}
//               {teamData.managers.secondary?.map((mgr, idx) => (
//                 <div key={idx} className="bg-gray-50/50 p-2 rounded-lg border-l-4 border-gray-400 shadow-sm">
//                   <p className="text-[8px] font-semibold text-gray-500 uppercase px-1 mb-1.5">Secondary Manager</p>
//                   <div className="flex items-center justify-between bg-white p-2.5 rounded-lg border border-gray-100">
//                     <div className="flex items-center gap-2.5">
//                       <img 
//                         src={mgr.profilePicture || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"} 
//                         className="w-8 h-8 rounded-full border object-cover shadow-sm" 
//                         alt="mgr" 
//                       />
//                       <div className="flex flex-col">
//                         <p className="text-[11px] font-bold text-gray-800 leading-tight">{mgr.name}</p>
//                         <p className="text-[10px] text-gray-500 font-semibold leading-tight mt-0.5">{mgr.designation}</p>
//                         <p className="text-[9px] text-gray-400 font-mono tracking-tighter uppercase">{mgr.userId}</p>
//                       </div>
//                     </div>
//                     {/* UPDATED: துணை மேலாளர்கள் நேற்று செக்-அவுட் செய்யவில்லை என்றால் "In (Yesterday)" என்று காட்டும் */}
//                     <div className={`px-2 py-0.5 rounded-full text-[9px] font-semibold uppercase ${getStatusConfig(mgr.status, false).class}`}>
//                       {getStatusConfig(mgr.status, false).label}
//                       {mgr.isYesterdayPunch && " (Yesterday)"}
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* 2. REPORTEES SECTION */}
//         <div className="space-y-3">
//           <div className="flex justify-between items-center px-2">
//             <h3 className="text-[11px] font-semibold text-textMuted uppercase tracking-widest">My Reportees</h3>
//             <Users size={12} className="text-textMuted" />
//           </div>

//           <div className="space-y-2">
//             {teamData.reportees?.length > 0 ? (
//               teamData.reportees.map((emp, idx) => (
//                 <div key={idx} className="flex items-center justify-between bg-white p-3 rounded-xl border border-gray-100 shadow-sm hover:border-red-100 transition-colors">
//                   <div className="flex items-center gap-3">
//                     <div className="flex items-center gap-2.5">
//                       <img 
//                         src={emp.profilePicture || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"} 
//                         className="w-10 h-10 rounded-full border object-cover shadow-sm" 
//                         alt="mgr" 
//                       />
//                     </div>
//                     <div className="flex flex-col">
//                       <p className="text-[11px] font-bold text-gray-700 leading-tight">{emp.name}</p>
//                       <p className="text-[10px] text-textMuted font-medium italic leading-tight mt-0.5">{emp.designation}</p>
//                       <p className="text-[9px] text-gray-400 font-mono tracking-tighter uppercase">{emp.userId}</p>
//                     </div>
//                   </div>
//                   {/* UPDATED: பணியாளர் நேற்று செக்-அவுட் செய்யவில்லை என்றால் "In (Yesterday)" என்று காட்டும் */}
//                   <div className={`px-2 py-0.5 rounded-full text-[9px] font-semibold uppercase ${getStatusConfig(emp.currentStatus || emp.status, false).class}`}>
//                     {getStatusConfig(emp.currentStatus || emp.status, false).label}
//                     {emp.isYesterdayPunch && " (Yesterday)"}
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div className="text-center py-6 bg-gray-50/50 rounded-xl border border-dashed border-gray-200">
//                 <p className="text-[10px] font-bold text-textMuted uppercase tracking-tighter">No Direct Reportees</p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//         {/* Timeline */}
//         <div className="space-y-4 px-2">
//           <h3 className="text-[11px] font-bold text-textMuted uppercase tracking-widest">Recent Logs</h3>
//           <div className="border-l-2 border-red-100 ml-3 space-y-4">
//             {attendance?.punches?.slice(-3).reverse().map((punch, idx) => (
//               <div key={idx} className="relative pl-6">
//                 <div className={`absolute left-[-9px] top-1 w-4 h-4 rounded-full border-2 border-white ${punch.type === "in" ? "bg-green-500" : "bg-red-500"}`}></div>
//                 <p className="text-[10px] font-bold text-gray-700">{punch.type === "in" ? "Check In" : "Check Out"}</p>
//                 <p className="text-[9px] text-textMuted">
//                   {format(new Date(punch.time), "hh:mm a")}
//                   {isPastRecord && " (Yesterday)"}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="lg:col-span-8 xl:col-span-9 space-y-6">
//         {/* Banner */}
//         <div className="flex flex-col xl:flex-row gap-6">
//           <div className="flex-1 bg-red-600 rounded-lg p-10 relative overflow-hidden flex items-center text-white shadow-xl">
//             <div className="z-10">
//               <h1 className="text-2xl md:text-3xl font-bold mb-2">Welcome, {user?.firstName} 👋</h1>
//               <p className="opacity-80 text-sm font-medium">Your presence is valued. Have a great day!</p>
//             </div>
//             <div className="absolute -right-10 -top-10 w-48 h-48 bg-white/10 rounded-full blur-3xl"></div>
//           </div>

//           <div className={`w-full xl:w-80 rounded-lg p-8 border ${isShiftEnded ? "bg-gray-100 border-gray-200" : "bg-orange-50 border-orange-100"}`}>
//             <div className={`flex items-center gap-2 mb-2 font-bold text-[12px] uppercase tracking-widest ${isShiftEnded ? "text-gray-500" : "text-orange-600"}`}>
//               {isShiftEnded ? <BellOff size={16} /> : <Bell size={16} fill="currentColor" />}
//               {isShiftEnded ? "Shift Ended" : "Active Shift"}
//             </div>
//             <p className="text-xl font-bold text-gray-700">
//               {formatTime12h(shiftTimings.startTime)} – {formatTime12h(shiftTimings.endTime)}
//             </p>
//           </div>
//         </div>

//         {/* Work Schedule (API Based) */}
//         <div className="bg-gray-100/30 rounded-lg p-6 border border-gray-200">
//           <div className="flex justify-between items-center mb-6 px-2">
//             <h3 className="text-base font-bold text-gray-700 uppercase">Work Schedule</h3>
//             <div className="text-[12px] font-bold text-white bg-red-600 px-4 py-2 rounded-md shadow-sm uppercase">
//               Weekly View
//             </div>
//           </div>
          
//           <div className="overflow-x-auto pb-6 custom-scrollbar">
//               <div className="flex lg:grid lg:grid-cols-7 gap-3 min-w-max py-4 px-4">
//                 {weeklySummary.map((day, idx) => {
//                   const dayDate = new Date(day.date);
//                   const isToday = isSameDay(dayDate, new Date());
                  
//                   const isDayWithActivePunch = attendance && isCurrentlyIn && isSameDay(dayDate, new Date(attendance.date));
//                   const dayStatus = isDayWithActivePunch ? 'checked_in' : day.status;

//                   const cfg     = WEEK_STATUS_CFG[dayStatus] || WEEK_STATUS_CFG.upcoming;

//                   return (
//                     <div
//                       key={idx}
//                       className={`rounded-lg p-3 text-center transition-all border w-[110px] lg:w-full
//                         ${isToday ? 'bg-blue-100 border-blue-700 text-white shadow-lg scale-105 z-10' : `${cfg.card}`}`}
//                     >
//                       {/* Day name */}
//                       <p className={`text-[10px] font-semibold uppercase tracking-widest mb-1
//                         ${isToday ? 'text-gray-700' : 'text-gray-700'}`}>
//                         {format(dayDate, 'EEE')}
//                       </p>

//                       {/* Date number */}
//                       <p className={`text-base font-semibold mb-2
//                         ${isToday ? 'text-gray-700' : 'text-gray-700'}`}>
//                         {format(dayDate, 'dd')}
//                       </p>

//                       {/* Status dot + badge */}
//                       <div className="flex flex-col items-center gap-1">
//                         <span className={`w-2 h-2 rounded-full mx-auto
//                           ${isToday ? 'bg-green-700' : cfg.bg}`}
//                         />
//                         <span className={`text-[9px] font-semibold uppercase tracking-tight px-1.5 py-0.5 rounded-full
//                           ${isToday ? 'bg-green-200 text-gray-700' : cfg.badge}`}>
//                           {cfg.label}
//                         </span>
//                       </div>

//                       {/* Holiday name (if any) */}
//                       {day.holidayName && (
//                         <p className={`text-[10px] font-semibold mt-1 truncate
//                           ${isToday ? 'text-white/70' : 'text-pink-600'}`}
//                           title={day.holidayName}>
//                           {day.holidayName}
//                         </p>
//                       )}

//                       {/* Working hours for present days */}
//                       {(dayStatus === 'present' || dayStatus === 'late') && day.totalWorkingMinutes > 0 && (
//                         <p className={`text-[8px] mt-1 font-medium
//                           ${isToday ? 'text-white/70' : 'text-gray-400'}`}>
//                           {fmtDur(day.totalWorkingMinutes)}
//                         </p>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//           </div>
//         </div>

//         {/* Timeline View */}
//         {(() => {
//           const shiftStart = hhmToMins(attendance?.shiftId?.startTime || shiftTimings.startTime);
//           const shiftEnd   = hhmToMins(attendance?.shiftId?.endTime   || shiftTimings.endTime);
//           const grace      = attendance?.shiftId?.graceMinutes || 15;
          
//           let nowMins = new Date().getHours() * 60 + new Date().getMinutes();
//           if (isPastRecord && attendance?.date) {
//             const [startH, startM] = shiftTimings.startTime.split(":").map(Number);
//             const todaysShiftStartMins = 1440 + (startH * 60 + startM);
            
//             const recordMidnight = new Date(attendance.date);
//             recordMidnight.setHours(0, 0, 0, 0);
//             const currentElapsedMins = Math.floor((new Date() - recordMidnight) / 60000);
            
//             nowMins = Math.min(currentElapsedMins, todaysShiftStartMins);
//           }
            
//           const punches    = attendance?.punches || [];

//           if (!punches.length) return (
//             <div className="mt-4 pt-6 border-t border-gray-200/60 text-center py-6">
//               <p className="text-[10px] text-gray-300 font-semibold uppercase tracking-widest">
//                 No punches yet today
//               </p>
//             </div>
//           );

//           const { segments, markers } = buildSegments(punches, shiftStart, shiftEnd, grace, nowMins);

//           const breakMins = attendance?.totalBreakMinutes || 0;
//           const lateMins  = attendance?.lateMinutes || 0;
//           const otMins    = attendance?.overtimeMinutes || 0;

//           return (
//             <div className="bg-gray-100/30 rounded-lg p-6 border border-gray-200">
//               {/* Header */}
//               <div className="flex flex-wrap justify-between items-center mb-4 px-2 gap-2">
//                 <h4 className="text-base font-bold text-gray-700 uppercase">
//                   {isPastRecord ? "Yesterday's Punch Timeline" : "Today's Punch Timeline"}
//                 </h4>
//                 <div className="flex flex-wrap gap-1.5">
//                   {lateMins > 0 && (
//                     <span className="text-[10px] font-bold bg-red-50 text-red-600 px-2 py-1 rounded-full">
//                       Late {fmtDur(lateMins)}
//                     </span>
//                   )}
//                   <span className="text-[10px] font-bold bg-green-50 text-green-600 px-2 py-1 rounded-full">
//                     Work {timerDisplay}
//                   </span>
//                   {breakMins > 0 && (
//                     <span className="text-[10px] font-bold bg-amber-50 text-amber-600 px-2 py-1 rounded-full">
//                       Break {fmtDur(breakMins)}
//                     </span>
//                   )}
//                   {otMins > 0 && (
//                     <span className="text-[10px] font-bold bg-purple-50 text-purple-600 px-2 py-1 rounded-full">
//                       OT {fmtDur(otMins)}
//                     </span>
//                   )}
//                 </div>
//               </div>

//               {/* Timeline bar */}
//               <div className="px-4 pb-2">

//                 {/* Time markers (top) */}
//                 <div className="relative h-5 mb-1">
//                   {markers.map((m, i) => (
//                     <div
//                       key={i}
//                       className="absolute flex flex-col items-center"
//                       style={{ left: `${m.pct}%`, transform: 'translateX(-50%)' }}
//                     >
//                       <span className={`text-[10px] font-semibold whitespace-nowrap
//                         ${m.isShift || m.isShiftEnd ? 'text-red-500' : m.isNow ? 'text-blue-500' : 'text-gray-400'}`}>
//                         {m.label}
//                       </span>
//                     </div>
//                   ))}
//                 </div>

//                 {/* Main bar */}
//                 <div className="relative h-2.5 bg-gray-100 rounded-full overflow-visible">

//                   {/* Filled segments */}
//                   {segments.map((seg) => (
//                     <div
//                       key={seg.key}
//                       className={`absolute top-0 h-full rounded-full ${seg.color}
//                         ${seg.pulse ? 'animate-pulse' : ''}`}
//                       style={{ left: `${seg.start}%`, width: `${Math.max(seg.width, 0.5)}%` }}
//                     />
//                   ))}

//                   {/* Shift end marker line */}
//                   {(() => {
//                     const punchPs = punches.map(p => isoToLocalMins(p.time));
//                     const lastP   = punches[punches.length - 1];
//                     const isIn    = lastP?.type === 'in';
//                     const wEnd    = Math.max(shiftEnd + 30, isIn ? nowMins + 30 : (punchPs.slice(-1)[0] || shiftEnd) + 30);
//                     const wDur    = wEnd - shiftStart;
//                     const seP     = Math.max(0, Math.min(100, ((shiftEnd - shiftStart) / wDur) * 100));
                    
//                     return (
//                       <div
//                         className="absolute top-0 h-full w-0.5 bg-red-600 z-10 rounded-full"
//                         style={{ left: `${seP}%` }}
//                         title={`Shift ends ${minsTo12h(shiftEnd)}`}
//                       />
//                     );
//                   })()}

//                   {/* Punch dots on the bar */}
//                   {punches.map((p, i) => {
//                     const punchPs = punches.map(pp => isoToLocalMins(pp.time));
//                     const lastP   = punches[punches.length - 1];
//                     const isIn_   = lastP?.type === 'in';
//                     const wEnd    = Math.max(shiftEnd + 30, isIn_ ? nowMins + 30 : (punchPs.slice(-1)[0] || shiftEnd) + 30);
//                     const wDur    = wEnd - shiftStart;
//                     const dotPct  = Math.max(0, Math.min(100, ((isoToLocalMins(p.time) - shiftStart) / wDur) * 100));
//                     return (
//                       <div
//                         key={i}
//                         className={`absolute top-1/2 -translate-y-1/2 w-3.5 h-3.5 rounded-full border-2 border-white z-10 shadow-md
//                           ${p.type === 'in' ? 'bg-green-600' : 'bg-red-600'}`}
//                         style={{ left: `${dotPct}%`, transform: 'translate(-50%, -50%)' }}
//                         title={`${p.type === 'in' ? 'Check In' : 'Check Out'} at ${format(new Date(p.time), 'hh:mm a')}`}
//                       />
//                     );
//                   })}
//                 </div>

//                 {/* Segment labels (bottom) */}
//                 <div className="relative h-10 mt-1">
//                   {segments.map((seg) => (
//                     <div
//                       key={seg.key + '-lbl'}
//                       className="absolute flex flex-col items-center"
//                       style={{
//                         left:  `${seg.start + seg.width / 2}%`,
//                         transform: 'translateX(-50%)',
//                       }}
//                     >
//                       <span className={`text-[10px] font-semibold whitespace-nowrap
//                         ${seg.color === 'bg-green-500' ? 'text-green-700'
//                           : seg.color === 'bg-amber-500' ? 'text-amber-700'
//                           : seg.color === 'bg-red-600'   ? 'text-red-700'
//                           : seg.color === 'bg-purple-600' ? 'text-purple-700'
//                           : 'text-gray-500'}`}>
//                         {seg.label}
//                       </span>
//                       <span className="text-[9px] text-slate-500 whitespace-nowrap font-medium">
//                         {seg.sublabel}
//                       </span>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Legend */}
//               <div className="flex flex-wrap gap-4 mt-2 px-4">
//                 {[
//                   ['bg-red-400',    'Late'],
//                   ['bg-green-500',  'Working'],
//                   ['bg-amber-300',  'Break'],
//                   ['bg-purple-500', 'Overtime'],
//                 ].map(([bg, label]) => (
//                   <div key={label} className="flex items-center gap-1.5">
//                     <span className={`w-2 h-2 rounded-full ${bg}`} />
//                     <span className="text-[10px] text-gray-400 font-semibold">{label}</span>
//                   </div>
//                 ))}
//                 <div className="flex items-center gap-1.5 ml-auto">
//                   <span className="w-0.5 h-3 bg-red-600 rounded-full" />
//                   <span className="text-[10px] text-gray-400 font-semibold">Shift End</span>
//                 </div>
//               </div>
//             </div>
//           );
//         })()}

//         {/* Stats Grid */}
//         <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
//           <div className="bg-white rounded-lg p-8 shadow-sm border border-gray-50">
//             <p className="text-textMuted text-[9px] font-bold uppercase tracking-widest mb-4">Effective Hours</p>
//             <span className="text-3xl font-bold text-gray-800">{timerDisplay}</span>
//           </div>
//           <div className="bg-white rounded-lg p-8 shadow-sm border border-gray-50">
//             <p className="text-textMuted text-[9px] font-bold uppercase tracking-widest mb-4">Break Time</p>
//             <span className="text-3xl font-bold text-gray-800">{attendance?.totalBreakMinutes || 0}m</span>
//           </div>
//           <div className="bg-white rounded-lg p-8 shadow-sm border border-gray-50">
//             <p className="text-textMuted text-[9px] font-bold uppercase mb-4">Pending Requests</p>
//             <div className="flex items-center justify-between">
//               <span className="text-3xl font-bold text-gray-800">{stats.pending}</span>
//               <ChevronRight size={20} className="text-gray-300" />
//             </div>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default AttendanceDashboard;

import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Bell, BellOff, Users, ChevronRight } from "lucide-react";
import { toast } from "react-toastify";
import { format, isSameDay } from "date-fns";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import PageLoader from "../../helpers/PageLoader";
import { useSelector } from "react-redux";

const WEEK_STATUS_CFG = {
  present:        { label: "Present",   bg: "bg-green-500",  card: "bg-green-50 border-green-200",   text: "text-green-700",   badge: "bg-green-100 text-green-700"   },
  checked_in:     { label: "In",        bg: "bg-blue-500",   card: "bg-blue-50 border-blue-200",     text: "text-blue-700",    badge: "bg-blue-100 text-blue-700"     },
  late:           { label: "Late",   bg: "bg-amber-400",  card: "bg-amber-50 border-amber-200",   text: "text-amber-700",   badge: "bg-amber-100 text-amber-700"   },
  half_day:       { label: "½",   bg: "bg-blue-400",   card: "bg-blue-50 border-blue-200",     text: "text-blue-700",    badge: "bg-blue-100 text-blue-700"     },
  absent:         { label: "Absent",   bg: "bg-red-500",    card: "bg-red-50 border-red-200",       text: "text-red-700",     badge: "bg-red-100 text-red-700"       },
  on_leave:       { label: "Leave",   bg: "bg-purple-400", card: "bg-purple-50 border-purple-200", text: "text-purple-700",  badge: "bg-purple-100 text-purple-700" },
  holiday:        { label: "Holiday",   bg: "bg-pink-400",   card: "bg-pink-50 border-pink-200",     text: "text-pink-700",    badge: "bg-pink-100 text-pink-700"     },
  week_off:       { label: "Week_Off",   bg: "bg-gray-300",   card: "bg-gray-50 border-gray-200",     text: "text-gray-400",    badge: "bg-gray-100 text-gray-400"     },
  comp_off:       { label: "C",   bg: "bg-teal-400",   card: "bg-teal-50 border-teal-200",     text: "text-teal-700",    badge: "bg-teal-100 text-teal-700"     },
  upcoming:       { label: "Future",   bg: "bg-gray-200",   card: "bg-gray-50 border-gray-100",     text: "text-gray-300",    badge: "bg-gray-50 text-gray-300"      },
  yet_to_checkin: { label: "Yet_to_Checkin",   bg: "bg-orange-400", card: "bg-orange-50 border-orange-200", text: "text-orange-600",  badge: "bg-orange-100 text-orange-600" },
  not_checked_in: { label: "?",   bg: "bg-orange-400", card: "bg-orange-50 border-orange-200", text: "text-orange-600",  badge: "bg-orange-100 text-orange-600" },
};

const AttendanceDashboard = () => {
  const user = useSelector((state) => state.user.user);
  
  const [attendance, setAttendance] = useState(null);
  const [weeklySummary, setWeeklySummary] = useState([]);
  const [teamData, setTeamData] = useState({ managers: { primary: null, secondary: [] }, reportees: [] });
  const [timerDisplay, setTimerDisplay] = useState("00:00:00");
  const [stats] = useState({ pending: 0, goal: 65 });
  const [loading, setLoading] = useState(true);
  const [isPunching, setIsPunching] = useState(false);

  const formatTime12h = (timeString) => {
    if (!timeString) return "--:--";
    const [hours, minutes] = timeString.split(":");
    let h = parseInt(hours, 10);
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${h}:${minutes} ${ampm}`;
  };

  const shiftTimings = useMemo(() => {
    const startTime = attendance?.shiftId?.startTime || user?.shiftId?.startTime || "09:00";
    const endTime = attendance?.shiftId?.endTime || user?.shiftId?.endTime || "18:00";
    return { startTime, endTime };
  }, [attendance, user]);

  const isShiftEnded = useMemo(() => {
    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();
    const [endH, endM] = shiftTimings.endTime.split(":").map(Number);
    return currentMinutes >= (endH * 60 + endM);
  }, [shiftTimings]);

  const isPastRecord = useMemo(() => {
    if (!attendance?.date) return false;
    return !isSameDay(new Date(attendance.date), new Date());
  }, [attendance]);

  const fetchDashboardData = useCallback(async () => {
    try {
      setLoading(true);
      const [todayRes, weeklyRes, teamRes] = await Promise.all([
        api.get(SummaryApi.getTodayAttendanceStatus.url),
        api.get(SummaryApi.weeklyAttendanceStatus.url),
        api.get(SummaryApi.teamTdyAttendanceStatus.url),
      ]);
      if (todayRes.data.success) setAttendance(todayRes.data.data);
      if (weeklyRes.data.success) setWeeklySummary(weeklyRes.data.data);
      if (teamRes.data.success) setTeamData(teamRes.data.data);
    } catch (err) {
      console.error("Error fetching dashboard data", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  useEffect(() => {
    let interval;
    const updateTimer = () => {
      if (!attendance || !attendance.punches || attendance.punches.length === 0) {
        setTimerDisplay("00:00:00");
        return;
      }
      const lastPunch = attendance.punches[attendance.punches.length - 1];
      let totalMs = (attendance.totalWorkingMinutes || 0) * 60000;

      // UPDATED: Added condition to ensure timer doesn't run if the session is marked as absent
      if (lastPunch.type === "in" && attendance.status !== 'absent') {
        const checkInTime = new Date(lastPunch.time);
        let endTimeToCalculate = new Date();

        if (isPastRecord) {
          const [startH, startM] = shiftTimings.startTime.split(":").map(Number);
          const todaysShiftStart = new Date();
          todaysShiftStart.setHours(startH, startM, 0, 0);

          if (endTimeToCalculate > todaysShiftStart) {
            endTimeToCalculate = todaysShiftStart;
          }
        }

        const diff = Math.max(0, endTimeToCalculate - checkInTime);
        totalMs += diff;
      }

      const totalSeconds = Math.floor(totalMs / 1000);
      const h = Math.floor(totalSeconds / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = totalSeconds % 60;
      setTimerDisplay(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`);
    };
    interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [attendance, isPastRecord, shiftTimings]);

  const handlePunchAction = async () => {
    if (isPunching) return;

    if (navigator.geolocation) {
      setIsPunching(true);

      navigator.geolocation.getCurrentPosition(async (pos) => {
        try {
          const lastPunch = attendance?.punches?.[attendance.punches.length - 1];
          const isCurrentlyIn = lastPunch?.type === "in" && attendance?.status !== 'absent';
          
          const payload = { 
            location: { lat: pos.coords.latitude, lng: pos.coords.longitude }, 
            method: "web",
            workMode: "office" 
          };

          const res = await api.post(isCurrentlyIn ? SummaryApi.checkOut.url : SummaryApi.checkIn.url, payload);
          
          if (res.data.success) {
            toast.success(isCurrentlyIn ? "Checked Out!" : "Checked In!");
            await fetchDashboardData();
          }
        } catch (err) {
          toast.error(err.response?.data?.message || "Error occurred during punch");
        } finally {
          setIsPunching(false);
        }
      }, (err) => {
        setIsPunching(false);
        toast.error("Please enable location access to punch.");
      }, { enableHighAccuracy: true });
    } else {
      toast.error("Geolocation is not supported by your browser.");
    }
  };

  const getStatusConfig = (status, isCurrentlyIn) => {
    if (isCurrentlyIn || status === 'checked_in') {
      return { label: 'In', class: 'bg-blue-100 text-blue-600' };
    }
    switch (status) {
      case 'present': return { label: 'Present', class: 'bg-green-100 text-green-600' };
      case 'yet_to_checkin': return { label: 'Yet to check-in', class: 'bg-orange-100 text-orange-600' };
      case 'absent': return { label: 'Absent', class: 'bg-red-100 text-red-600' };
      case 'holiday': return { label: 'Holiday', class: 'bg-blue-100 text-blue-600' };
      case 'on_leave': return { label: 'On Leave', class: 'bg-purple-100 text-purple-600' };
      case 'week_off': return { label: 'Week Off', class: 'bg-gray-100 text-gray-400' };
      case 'inactive': return { label: '-', class: 'bg-gray-50 text-gray-300' };
      default: return { label: status, class: 'bg-gray-100 text-gray-600' };
    }
  };

  const hhmToMins = (hhmm) => {
    if (!hhmm) return 0;
    const [h, m] = hhmm.split(':').map(Number);
    return h * 60 + m;
  };

  const isoToLocalMins = (iso) => {
    const d = new Date(iso);
    return d.getHours() * 60 + d.getMinutes();
  };

  const fmtDur = (mins) => {
    if (!mins || mins <= 0) return '0m';
    const h = Math.floor(Math.abs(mins) / 60);
    const m = Math.abs(mins) % 60;
    if (h === 0) return `${m}m`;
    if (m === 0) return `${h}h`;
    return `${h}h ${m}m`;
  };

  const minsTo12h = (totalMins) => {
    const h = Math.floor(totalMins / 60) % 24;
    const m = totalMins % 60;
    const ampm = h >= 12 ? 'PM' : 'AM';
    return `${h % 12 || 12}:${String(m).padStart(2,'0')} ${ampm}`;
  };

  const buildSegments = (punches, shiftStart, shiftEnd, grace, nowMins) => {
    if (!punches?.length) return { segments: [], markers: [] };

    const ps = punches.map(p => ({ ...p, mins: isoToLocalMins(p.time) }));
    const firstIn = ps[0];
    const lastP   = ps[ps.length - 1];
    const isIn    = lastP.type === 'in' && attendance?.status !== 'absent';

    const windowEnd = Math.max(
      shiftEnd + 30,
      isIn ? nowMins + 30 : lastP.mins + 30
    );
    const windowDur = windowEnd - shiftStart;
    const pct = (m) => Math.max(0, Math.min(100, ((m - shiftStart) / windowDur) * 100));

    const segments = [];

    if (firstIn && firstIn.mins > shiftStart + grace) {
      segments.push({
        key:   'late',
        start: pct(shiftStart),
        width: pct(firstIn.mins) - pct(shiftStart),
        color: 'bg-red-400',
        label: `Late ${fmtDur(firstIn.mins - shiftStart)}`,
        sublabel: `${minsTo12h(shiftStart)} → ${minsTo12h(firstIn.mins)}`,
      });
    }

    for (let i = 0; i < ps.length; i++) {
      const cur  = ps[i];
      const next = ps[i + 1];

      if (cur.type === 'in') {
        const endMins = next ? next.mins : (isIn ? nowMins : cur.mins);
        const dur = endMins - cur.mins;

        if (cur.mins < shiftEnd && endMins > shiftEnd) {
          const regDur = shiftEnd - cur.mins;
          segments.push({
            key:   `work-${i}-reg`,
            start: pct(cur.mins),
            width: pct(shiftEnd) - pct(cur.mins),
            color: 'bg-green-500',
            label: `Work ${fmtDur(regDur)}`,
            sublabel: `${minsTo12h(cur.mins)} → ${minsTo12h(shiftEnd)}`,
            pulse: false,
          });
          const otDur = endMins - shiftEnd;
          segments.push({
            key:   `ot-${i}`,
            start: pct(shiftEnd),
            width: pct(endMins) - pct(shiftEnd),
            color: 'bg-purple-500',
            label: `OT ${fmtDur(otDur)}`,
            sublabel: `${minsTo12h(shiftEnd)} → ${isIn && !next ? 'Now' : minsTo12h(endMins)}`,
            pulse: isIn && !next,
          });
        } else if (cur.mins >= shiftEnd) {
          segments.push({
            key:   `ot-${i}`,
            start: pct(cur.mins),
            width: pct(endMins) - pct(cur.mins),
            color: 'bg-purple-500',
            label: `OT ${fmtDur(dur)}`,
            sublabel: `${minsTo12h(cur.mins)} → ${isIn && !next ? 'Now' : minsTo12h(endMins)}`,
            pulse: isIn && !next,
          });
        } else {
          segments.push({
            key:   `work-${i}`,
            start: pct(cur.mins),
            width: pct(endMins) - pct(cur.mins),
            color: 'bg-green-500',
            label: `Work ${fmtDur(dur)}`,
            sublabel: `${minsTo12h(cur.mins)} → ${isIn && !next ? 'Now' : minsTo12h(endMins)}`,
            pulse: isIn && !next,
          });
        }
      }

      if (cur.type === 'out' && next?.type === 'in') {
        const dur = next.mins - cur.mins;
        segments.push({
          key:   `break-${i}`,
          start: pct(cur.mins),
          width: pct(next.mins) - pct(cur.mins),
          color: 'bg-amber-300',
          label: `Break ${fmtDur(dur)}`,
          sublabel: `${minsTo12h(cur.mins)} → ${minsTo12h(next.mins)}`,
        });
      }
    }

    const markerSet = new Map();
    markerSet.set(shiftStart, { mins: shiftStart, label: minsTo12h(shiftStart), isShift: true });
    markerSet.set(shiftEnd,   { mins: shiftEnd,   label: minsTo12h(shiftEnd),   isShiftEnd: true });
    ps.forEach(p => {
      markerSet.set(p.mins, { mins: p.mins, label: minsTo12h(p.mins), isPunch: true, type: p.type });
    });
    if (isIn) {
      markerSet.set(nowMins, { mins: nowMins, label: isPastRecord ? minsTo12h(nowMins) : 'Now', isNow: true });
    }

    const markers = [...markerSet.values()]
      .sort((a, b) => a.mins - b.mins)
      .map(m => ({ ...m, pct: pct(m.mins) }));

    return { segments, markers, windowEnd, windowDur, pct };
  };

  if (loading) return <PageLoader />;

  // UPDATED: Added status check to determine if the user is currently checked-in
  const isCurrentlyIn = attendance?.status !== 'absent' && attendance?.punches?.[attendance.punches.length - 1]?.type === "in";
  const todayStatus = attendance?.status || 'yet_to_checkin';

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 p-2 lg:p-0">
      
      {/* Sidebar - Profile & Team */}
      <div className="lg:col-span-4 xl:col-span-3 space-y-6">
        <div className="bg-white rounded-lg p-8 shadow-sm border border-red-50 text-center">
          <div className="relative inline-block mb-4">
            <div className="w-24 h-24 bg-gray-100 rounded-full mx-auto overflow-hidden border-4 border-white shadow-md">
              <img src={user?.profilePicture || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"} alt="User" className="w-full h-full object-cover" />
            </div>
            <div className={`absolute bottom-1 right-1 w-4 h-4 rounded-full border-2 border-white ${isCurrentlyIn ? "bg-green-500" : "bg-red-500"}`}></div>
          </div>
          <h2 className="text-xl font-bold text-gray-800">{user?.firstName} {user?.lastName}</h2>
          <p className="text-gray-500 text-[10px] mb-6 font-semibold uppercase tracking-widest">{user?.designationId?.title || "Employee"}</p>

          {/* Today Status Badge */}
          <div className={`inline-block px-4 py-1 rounded-full text-[10px] font-semibold uppercase mb-6 ${getStatusConfig(todayStatus, isCurrentlyIn).class}`}>
            Current: {getStatusConfig(todayStatus, isCurrentlyIn).label}
          </div>

          <div className="bg-red-50 text-red-600 font-mono text-2xl py-3 rounded-lg mb-4 tracking-widest border border-red-100">
            {timerDisplay}
          </div>

          {/* Warning indicator for past open sessions */}
          {isPastRecord && isCurrentlyIn && (
            <p className="text-[10px] text-red-500 font-bold animate-pulse mt-1 mb-4 uppercase tracking-wider">
              ⚠️ Yesterday's Open Session
            </p>
          )}

            <button 
              onClick={handlePunchAction} 
              disabled={isPunching} 
              className={`w-full py-4 rounded-lg font-bold shadow-lg text-white transition-all flex items-center justify-center gap-2 ${isPunching ? "opacity-70 cursor-not-allowed" : ""} ${isCurrentlyIn ? "bg-secondary" : "bg-red-600 hover:bg-red-700"}`}
            >
              {isPunching ? (
                <>
                  <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                  Processing...
                </>
              ) : (
                isCurrentlyIn ? (isPastRecord ? "Check-out Yesterday" : "Check-out") : "Check-in"
              )}
            </button>
        </div>

      {/* Team Section (Managers + Reportees) */}
      <div className="space-y-6">
        
        {/* 1. MANAGERS SECTION */}
        {(teamData.managers?.primary || teamData.managers?.secondary?.length > 0) && (
          <div className="space-y-3">
            <div className="flex justify-between items-center px-2">
              <h3 className="text-[11px] font-semibold text-textMuted uppercase tracking-widest">Reporting To</h3>
              <Users size={12} className="text-textMuted" />
            </div>

            <div className="space-y-3">
              {/* Primary Manager */}
              {teamData.managers.primary && (
                <div className="bg-red-50/30 p-2 rounded-lg border-l-4 border-red-600 shadow-sm">
                  <p className="text-[9px] font-semibold text-red-600 uppercase px-1 mb-1.5 flex items-center gap-1">
                    <span className="w-1 h-1 bg-red-600 rounded-full"></span> Primary Manager
                  </p>
                  <div className="flex items-center justify-between bg-white p-2.5 rounded-lg border border-red-100/50">
                    <div className="flex items-center gap-2.5">
                      <img 
                        src={teamData.managers.primary.profilePicture || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"} 
                        className="w-8 h-8 rounded-full border-2 border-red-50 object-cover shadow-sm" 
                        alt="mgr" 
                      />
                      <div className="flex flex-col">
                        <p className="text-[11px] font-bold text-gray-800 leading-tight">{teamData.managers.primary.name}</p>
                        <p className="text-[10px] text-red-500 font-semibold leading-tight mt-0.5">{teamData.managers.primary.designation}</p>
                        <p className="text-[8px] text-gray-400 font-mono tracking-tighter uppercase">{teamData.managers.primary.userId}</p>
                      </div>
                    </div>
                    <div className={`px-2 py-0.5 rounded-full text-[9px] font-semibold uppercase ${getStatusConfig(teamData.managers.primary.status, false).class}`}>
                      {getStatusConfig(teamData.managers.primary.status, false).label}
                      {teamData.managers.primary.isYesterdayPunch && " (Yesterday)"}
                    </div>
                  </div>
                </div>
              )}

              {/* Secondary Managers */}
              {teamData.managers.secondary?.map((mgr, idx) => (
                <div key={idx} className="bg-gray-50/50 p-2 rounded-lg border-l-4 border-gray-400 shadow-sm">
                  <p className="text-[8px] font-semibold text-gray-500 uppercase px-1 mb-1.5">Secondary Manager</p>
                  <div className="flex items-center justify-between bg-white p-2.5 rounded-lg border border-gray-100">
                    <div className="flex items-center gap-2.5">
                      <img 
                        src={mgr.profilePicture || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"} 
                        className="w-8 h-8 rounded-full border object-cover shadow-sm" 
                        alt="mgr" 
                      />
                      <div className="flex flex-col">
                        <p className="text-[11px] font-bold text-gray-800 leading-tight">{mgr.name}</p>
                        <p className="text-[10px] text-gray-500 font-semibold leading-tight mt-0.5">{mgr.designation}</p>
                        <p className="text-[9px] text-gray-400 font-mono tracking-tighter uppercase">{mgr.userId}</p>
                      </div>
                    </div>
                    <div className={`px-2 py-0.5 rounded-full text-[9px] font-semibold uppercase ${getStatusConfig(mgr.status, false).class}`}>
                      {getStatusConfig(mgr.status, false).label}
                      {mgr.isYesterdayPunch && " (Yesterday)"}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* 2. REPORTEES SECTION */}
        <div className="space-y-3">
          <div className="flex justify-between items-center px-2">
            <h3 className="text-[11px] font-semibold text-textMuted uppercase tracking-widest">My Reportees</h3>
            <Users size={12} className="text-textMuted" />
          </div>

          <div className="space-y-2">
            {teamData.reportees?.length > 0 ? (
              teamData.reportees.map((emp, idx) => (
                <div key={idx} className="flex items-center justify-between bg-white p-3 rounded-xl border border-gray-100 shadow-sm hover:border-red-100 transition-colors">
                  <div className="flex items-center gap-3">
                    <div className="flex items-center gap-2.5">
                      <img 
                        src={emp.profilePicture || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"} 
                        className="w-10 h-10 rounded-full border object-cover shadow-sm" 
                        alt="mgr" 
                      />
                    </div>
                    <div className="flex flex-col">
                      <p className="text-[11px] font-bold text-gray-700 leading-tight">{emp.name}</p>
                      <p className="text-[10px] text-textMuted font-medium italic leading-tight mt-0.5">{emp.designation}</p>
                      <p className="text-[9px] text-gray-400 font-mono tracking-tighter uppercase">{emp.userId}</p>
                    </div>
                  </div>
                  <div className={`px-2 py-0.5 rounded-full text-[9px] font-semibold uppercase ${getStatusConfig(emp.currentStatus || emp.status, false).class}`}>
                    {getStatusConfig(emp.currentStatus || emp.status, false).label}
                    {emp.isYesterdayPunch && " (Yesterday)"}
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center py-6 bg-gray-50/50 rounded-xl border border-dashed border-gray-200">
                <p className="text-[10px] font-bold text-textMuted uppercase tracking-tighter">No Direct Reportees</p>
              </div>
            )}
          </div>
        </div>
      </div>

        {/* Timeline */}
        <div className="space-y-4 px-2">
          <h3 className="text-[11px] font-bold text-textMuted uppercase tracking-widest">Recent Logs</h3>
          <div className="border-l-2 border-red-100 ml-3 space-y-4">
            {attendance?.punches?.slice(-3).reverse().map((punch, idx) => (
              <div key={idx} className="relative pl-6">
                <div className={`absolute left-[-9px] top-1 w-4 h-4 rounded-full border-2 border-white ${punch.type === "in" ? "bg-green-500" : "bg-red-500"}`}></div>
                <p className="text-[10px] font-bold text-gray-700">{punch.type === "in" ? "Check In" : "Check Out"}</p>
                <p className="text-[9px] text-textMuted">
                  {format(new Date(punch.time), "hh:mm a")}
                  {isPastRecord && " (Yesterday)"}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="lg:col-span-8 xl:col-span-9 space-y-6">
        {/* Banner */}
        <div className="flex flex-col xl:flex-row gap-6">
          <div className="flex-1 bg-red-600 rounded-lg p-10 relative overflow-hidden flex items-center text-white shadow-xl">
            <div className="z-10">
              <h1 className="text-2xl md:text-3xl font-bold mb-2">Welcome, {user?.firstName} 👋</h1>
              <p className="opacity-80 text-sm font-medium">Your presence is valued. Have a great day!</p>
            </div>
            <div className="absolute -right-10 -top-10 w-48 h-48 bg-white/10 rounded-full blur-3xl"></div>
          </div>

          <div className={`w-full xl:w-80 rounded-lg p-8 border ${isShiftEnded ? "bg-gray-100 border-gray-200" : "bg-orange-50 border-orange-100"}`}>
            <div className={`flex items-center gap-2 mb-2 font-bold text-[12px] uppercase tracking-widest ${isShiftEnded ? "text-gray-500" : "text-orange-600"}`}>
              {isShiftEnded ? <BellOff size={16} /> : <Bell size={16} fill="currentColor" />}
              {isShiftEnded ? "Shift Ended" : "Active Shift"}
            </div>
            <p className="text-xl font-bold text-gray-700">
              {formatTime12h(shiftTimings.startTime)} – {formatTime12h(shiftTimings.endTime)}
            </p>
          </div>
        </div>

        {/* Work Schedule (API Based) */}
        <div className="bg-gray-100/30 rounded-lg p-6 border border-gray-200">
          <div className="flex justify-between items-center mb-6 px-2">
            <h3 className="text-base font-bold text-gray-700 uppercase">Work Schedule</h3>
            <div className="text-[12px] font-bold text-white bg-red-600 px-4 py-2 rounded-md shadow-sm uppercase">
              Weekly View
            </div>
          </div>
          
          <div className="overflow-x-auto pb-6 custom-scrollbar">
              <div className="flex lg:grid lg:grid-cols-7 gap-3 min-w-max py-4 px-4">
                {weeklySummary.map((day, idx) => {
                  const dayDate = new Date(day.date);
                  const isToday = isSameDay(dayDate, new Date());
                  
                  const isDayWithActivePunch = attendance && isCurrentlyIn && isSameDay(dayDate, new Date(attendance.date));
                  const dayStatus = isDayWithActivePunch ? 'checked_in' : day.status;

                  const cfg     = WEEK_STATUS_CFG[dayStatus] || WEEK_STATUS_CFG.upcoming;

                  return (
                    <div
                      key={idx}
                      className={`rounded-lg p-3 text-center transition-all border w-[110px] lg:w-full
                        ${isToday ? 'bg-blue-100 border-blue-700 text-white shadow-lg scale-105 z-10' : `${cfg.card}`}`}
                    >
                      {/* Day name */}
                      <p className={`text-[10px] font-semibold uppercase tracking-widest mb-1
                        ${isToday ? 'text-gray-700' : 'text-gray-700'}`}>
                        {format(dayDate, 'EEE')}
                      </p>

                      {/* Date number */}
                      <p className={`text-base font-semibold mb-2
                        ${isToday ? 'text-gray-700' : 'text-gray-700'}`}>
                        {format(dayDate, 'dd')}
                      </p>

                      {/* Status dot + badge */}
                      <div className="flex flex-col items-center gap-1">
                        <span className={`w-2 h-2 rounded-full mx-auto
                          ${isToday ? 'bg-green-700' : cfg.bg}`}
                        />
                        <span className={`text-[9px] font-semibold uppercase tracking-tight px-1.5 py-0.5 rounded-full
                          ${isToday ? 'bg-green-200 text-gray-700' : cfg.badge}`}>
                          {cfg.label}
                        </span>
                      </div>

                      {/* Holiday name (if any) */}
                      {day.holidayName && (
                        <p className={`text-[10px] font-semibold mt-1 truncate
                          ${isToday ? 'text-white/70' : 'text-pink-600'}`}
                          title={day.holidayName}>
                          {day.holidayName}
                        </p>
                      )}

                      {/* Working hours for present days */}
                      {(dayStatus === 'present' || dayStatus === 'late') && day.totalWorkingMinutes > 0 && (
                        <p className={`text-[8px] mt-1 font-medium
                          ${isToday ? 'text-white/70' : 'text-gray-400'}`}>
                          {fmtDur(day.totalWorkingMinutes)}
                        </p>
                      )}
                    </div>
                  );
                })}
              </div>
          </div>
        </div>

        {/* Timeline View */}
        {(() => {
          const shiftStart = hhmToMins(attendance?.shiftId?.startTime || shiftTimings.startTime);
          const shiftEnd   = hhmToMins(attendance?.shiftId?.endTime   || shiftTimings.endTime);
          const grace      = attendance?.shiftId?.graceMinutes || 15;
          
          let nowMins = new Date().getHours() * 60 + new Date().getMinutes();
          if (isPastRecord && attendance?.date) {
            const [startH, startM] = shiftTimings.startTime.split(":").map(Number);
            const todaysShiftStartMins = 1440 + (startH * 60 + startM);
            
            const recordMidnight = new Date(attendance.date);
            recordMidnight.setHours(0, 0, 0, 0);
            const currentElapsedMins = Math.floor((new Date() - recordMidnight) / 60000);
            
            nowMins = Math.min(currentElapsedMins, todaysShiftStartMins);
          }
            
          const punches    = attendance?.punches || [];

          if (!punches.length) return (
            <div className="mt-4 pt-6 border-t border-gray-200/60 text-center py-6">
              <p className="text-[10px] text-gray-300 font-semibold uppercase tracking-widest">
                No punches yet today
              </p>
            </div>
          );

          const { segments, markers } = buildSegments(punches, shiftStart, shiftEnd, grace, nowMins);

          const breakMins = attendance?.totalBreakMinutes || 0;
          const lateMins  = attendance?.lateMinutes || 0;
          const otMins    = attendance?.overtimeMinutes || 0;

          return (
            <div className="bg-gray-100/30 rounded-lg p-6 border border-gray-200">
              {/* Header */}
              <div className="flex flex-wrap justify-between items-center mb-4 px-2 gap-2">
                <h4 className="text-base font-bold text-gray-700 uppercase">
                  {isPastRecord ? "Yesterday's Punch Timeline" : "Today's Punch Timeline"}
                </h4>
                <div className="flex flex-wrap gap-1.5">
                  {lateMins > 0 && (
                    <span className="text-[10px] font-bold bg-red-50 text-red-600 px-2 py-1 rounded-full">
                      Late {fmtDur(lateMins)}
                    </span>
                  )}
                  <span className="text-[10px] font-bold bg-green-50 text-green-600 px-2 py-1 rounded-full">
                    Work {timerDisplay}
                  </span>
                  {breakMins > 0 && (
                    <span className="text-[10px] font-bold bg-amber-50 text-amber-600 px-2 py-1 rounded-full">
                      Break {fmtDur(breakMins)}
                    </span>
                  )}
                  {otMins > 0 && (
                    <span className="text-[10px] font-bold bg-purple-50 text-purple-600 px-2 py-1 rounded-full">
                      OT {fmtDur(otMins)}
                    </span>
                  )}
                </div>
              </div>

              {/* Timeline bar */}
              <div className="px-4 pb-2">

                {/* Time markers (top) */}
                <div className="relative h-5 mb-1">
                  {markers.map((m, i) => (
                    <div
                      key={i}
                      className="absolute flex flex-col items-center"
                      style={{ left: `${m.pct}%`, transform: 'translateX(-50%)' }}
                    >
                      <span className={`text-[10px] font-semibold whitespace-nowrap
                        ${m.isShift || m.isShiftEnd ? 'text-red-500' : m.isNow ? 'text-blue-500' : 'text-gray-400'}`}>
                        {m.label}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Main bar */}
                <div className="relative h-2.5 bg-gray-100 rounded-full overflow-visible">

                  {/* Filled segments */}
                  {segments.map((seg) => (
                    <div
                      key={seg.key}
                      className={`absolute top-0 h-full rounded-full ${seg.color}
                        ${seg.pulse ? 'animate-pulse' : ''}`}
                      style={{ left: `${seg.start}%`, width: `${Math.max(seg.width, 0.5)}%` }}
                    />
                  ))}

                  {/* Shift end marker line */}
                  {(() => {
                    const punchPs = punches.map(p => isoToLocalMins(p.time));
                    const lastP   = punches[punches.length - 1];
                    const isIn    = lastP?.type === 'in' && attendance?.status !== 'absent';
                    const wEnd    = Math.max(shiftEnd + 30, isIn ? nowMins + 30 : (punchPs.slice(-1)[0] || shiftEnd) + 30);
                    const wDur    = wEnd - shiftStart;
                    const seP     = Math.max(0, Math.min(100, ((shiftEnd - shiftStart) / wDur) * 100));
                    
                    return (
                      <div
                        className="absolute top-0 h-full w-0.5 bg-red-600 z-10 rounded-full"
                        style={{ left: `${seP}%` }}
                        title={`Shift ends ${minsTo12h(shiftEnd)}`}
                      />
                    );
                  })()}

                  {/* Punch dots on the bar */}
                  {punches.map((p, i) => {
                    const punchPs = punches.map(pp => isoToLocalMins(pp.time));
                    const lastP   = punches[punches.length - 1];
                    const isIn_   = lastP?.type === 'in' && attendance?.status !== 'absent';
                    const wEnd    = Math.max(shiftEnd + 30, isIn_ ? nowMins + 30 : (punchPs.slice(-1)[0] || shiftEnd) + 30);
                    const wDur    = wEnd - shiftStart;
                    const dotPct  = Math.max(0, Math.min(100, ((isoToLocalMins(p.time) - shiftStart) / wDur) * 100));
                    return (
                      <div
                        key={i}
                        className={`absolute top-1/2 -translate-y-1/2 w-3.5 h-3.5 rounded-full border-2 border-white z-10 shadow-md
                          ${p.type === 'in' ? 'bg-green-600' : 'bg-red-600'}`}
                        style={{ left: `${dotPct}%`, transform: 'translate(-50%, -50%)' }}
                        title={`${p.type === 'in' ? 'Check In' : 'Check Out'} at ${format(new Date(p.time), 'hh:mm a')}`}
                      />
                    );
                  })}
                </div>

                {/* Segment labels (bottom) */}
                <div className="relative h-10 mt-1">
                  {segments.map((seg) => (
                    <div
                      key={seg.key + '-lbl'}
                      className="absolute flex flex-col items-center"
                      style={{
                        left:  `${seg.start + seg.width / 2}%`,
                        transform: 'translateX(-50%)',
                      }}
                    >
                      <span className={`text-[10px] font-semibold whitespace-nowrap
                        ${seg.color === 'bg-green-500' ? 'text-green-700'
                          : seg.color === 'bg-amber-500' ? 'text-amber-700'
                          : seg.color === 'bg-red-600'   ? 'text-red-700'
                          : seg.color === 'bg-purple-600' ? 'text-purple-700'
                          : 'text-gray-500'}`}>
                        {seg.label}
                      </span>
                      <span className="text-[9px] text-slate-500 whitespace-nowrap font-medium">
                        {seg.sublabel}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Legend */}
              <div className="flex flex-wrap gap-4 mt-2 px-4">
                {[
                  ['bg-red-400',    'Late'],
                  ['bg-green-500',  'Working'],
                  ['bg-amber-300',  'Break'],
                  ['bg-purple-500', 'Overtime'],
                ].map(([bg, label]) => (
                  <div key={label} className="flex items-center gap-1.5">
                    <span className={`w-2 h-2 rounded-full ${bg}`} />
                    <span className="text-[10px] text-gray-400 font-semibold">{label}</span>
                  </div>
                ))}
                <div className="flex items-center gap-1.5 ml-auto">
                  <span className="w-0.5 h-3 bg-red-600 rounded-full" />
                  <span className="text-[10px] text-gray-400 font-semibold">Shift End</span>
                </div>
              </div>
            </div>
          );
        })()}

        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          <div className="bg-white rounded-lg p-8 shadow-sm border border-gray-50">
            <p className="text-textMuted text-[9px] font-bold uppercase tracking-widest mb-4">Effective Hours</p>
            <span className="text-3xl font-bold text-gray-800">{timerDisplay}</span>
          </div>
          <div className="bg-white rounded-lg p-8 shadow-sm border border-gray-50">
            <p className="text-textMuted text-[9px] font-bold uppercase tracking-widest mb-4">Break Time</p>
            <span className="text-3xl font-bold text-gray-800">{attendance?.totalBreakMinutes || 0}m</span>
          </div>
          <div className="bg-white rounded-lg p-8 shadow-sm border border-gray-50">
            <p className="text-textMuted text-[9px] font-bold uppercase mb-4">Pending Requests</p>
            <div className="flex items-center justify-between">
              <span className="text-3xl font-bold text-gray-800">{stats.pending}</span>
              <ChevronRight size={20} className="text-gray-300" />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AttendanceDashboard;